/**
 * URL-driven search params for the cache-telemetry dashboard.
 *
 * @module pages/superadmin/cache-telemetry/useCacheTelemetrySearch
 */
import { useSearch, useNavigate } from '@tanstack/react-router';

const ROUTE_PATH = '/superadmin/cache-telemetry' as const;
const DEFAULT_DAYS = 7;

export type CacheTelemetrySearchParams = {
  days?: number;
  workflowId?: string;
};

export function useCacheTelemetrySearch() {
  const search = useSearch({ from: ROUTE_PATH }) as CacheTelemetrySearchParams;
  const navigate = useNavigate();

  const updateSearch = (updates: Partial<CacheTelemetrySearchParams>) => {
    const merged = { ...search, ...updates };
    const cleaned: Record<string, unknown> = {};
    if (merged.days && merged.days !== DEFAULT_DAYS) cleaned.days = merged.days;
    if (merged.workflowId) cleaned.workflowId = merged.workflowId;
    navigate({ to: ROUTE_PATH, search: cleaned, replace: true });
  };

  return { search, updateSearch, days: search.days ?? DEFAULT_DAYS };
}
